// Saves made with no signal wait here (IndexedDB) and are sent in order once the phone is back online.
import { toast } from "sonner";

const DB = "snaplist-outbox", STORE = "q";
const localPhotos = new Map(); // photo id -> blob URL, so photos taken offline show right away
let dbp = null;
let sending = false;
const subs = new Set();

const idb = () => {
  if (!dbp) {
    dbp = new Promise((res) => {
      try {
        const r = indexedDB.open(DB, 1);
        r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: "seq", autoIncrement: true });
        r.onsuccess = () => res(r.result);
        r.onerror = () => res(null);
      } catch { res(null); }
    });
  }
  return dbp;
};
const run = async (mode, fn) => {
  const db = await idb();
  if (!db) return null;
  return new Promise((res) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => res(req?.result ?? null);
    t.onerror = () => res(null);
  });
};

export const localPhotoUrl = (id) => localPhotos.get(id);
export const outboxCount = async () => (await run("readonly", (s) => s.count())) || 0;
export const onOutbox = (fn) => { subs.add(fn); return () => subs.delete(fn); };
const notify = async () => { const n = await outboxCount(); subs.forEach((f) => f(n)); };

export async function enqueue(item) {
  if (item.file && item.photoId) localPhotos.set(item.photoId, URL.createObjectURL(item.file));
  await run("readwrite", (s) => s.add({ ...item, at: Date.now() }));
  notify();
}

// send(item) -> resolves when the server took it; throws { offline: true } to stop and retry later.
export async function flush(send) {
  if (sending || !navigator.onLine) return;
  sending = true;
  let sent = 0;
  try {
    const items = (await run("readonly", (s) => s.getAll())) || [];
    for (const it of items) {
      try { await send(it); sent += 1; } catch (e) {
        if (e?.offline) break;
        toast.error(`Couldn't send a saved ${it.kind === "photo" ? "photo" : "change"}: ${e?.message || "server said no"}`);
      }
      await run("readwrite", (s) => s.delete(it.seq));
    }
  } finally {
    sending = false;
    notify();
    if (sent) {
      toast.success(`Back online: sent ${sent} saved change${sent === 1 ? "" : "s"}`);
      window.dispatchEvent(new Event("snaplist:outbox-sent"));
    }
  }
}

// After a reload with photos still waiting, rebuild their previews from the saved files.
export async function restorePreviews() {
  const items = (await run("readonly", (s) => s.getAll())) || [];
  items.forEach((it) => { if (it.kind === "photo" && it.file && !localPhotos.has(it.photoId)) localPhotos.set(it.photoId, URL.createObjectURL(it.file)); });
}
restorePreviews();
